import { useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//Common
import { TextField } from "../../common/VFX-UI";
import ActionBar from "../../common/ActionBar/ActionBar";
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";

//App
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { RoleFormProps } from "../../../types/role";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});

const RoleForm = (props: RoleFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);

  const { id } = initialVal;
  const title = id === EMPTY_GUID ? "New Role" : "Edit Role";

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {() => (
          <Form noValidate>
            <TextField label="Name" type="text" name="name" />
            <ActionBar
              submitHandler={saveInput}
              cancelHandler={onClose}
              submitText="Submit"
              cancelText="Cancel"
              isLoading={status === "pending"}
            ></ActionBar>
          </Form>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default RoleForm;
